import React, { useEffect, useState } from 'react';
import { getEventMenuPropsFromEvent } from '../../../layout.utils';
import { CustomizableHeader } from '../CustomizableHeader/CustomizableHeader';
import EventMenu from '../EventMenu/EventMenu';
import { useWebsiteHeaderSettings } from '@apps/guest/websiteHeader';
import { usePageRefFromUrl } from '../../hooks/usePageRefFromUrl';
import { EventPageFragment, EventPageType } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';
import { GuestSiteEvent } from '../../../layout.types';
import { LegacyHeader } from '../LegacyHeader/LegacyHeader';

type TelemetryEditPhotoActions = {
  onChangePhotoButtonClicked: () => void;
  onEditPhotoOpenedChange: (opened: boolean) => void;
  onFocusPointChange: (prevPoint: unknown, newPoint: unknown) => void;
  onFocusPointChangeError: (error: unknown) => void;
};

type WebsiteHeaderProps = {
  eventDisplayName?: string | null;
  greeting?: string | null;
  artBackgroundFontColor?: string;
  telemetryEditPhotoActions: TelemetryEditPhotoActions;
  handleMenuOpenedChange: (isOpen: boolean) => void;
  handleMenuClicked: (pageClicked: string) => void;
  event: GuestSiteEvent;
  pages: EventPageFragment[];
};

export const WebsiteHeader = ({
  eventDisplayName,
  greeting,
  artBackgroundFontColor,
  telemetryEditPhotoActions,
  handleMenuOpenedChange,
  handleMenuClicked,
  event,
  pages
}: WebsiteHeaderProps) => {
  const [isWelcomePage, setIsWelcomePage] = useState(false);
  const { eventHandle } = useEventInfo();
  const { websiteHeader } = useWebsiteHeaderSettings({
    websiteLayout: 'aloha',
    presentationLayout: 'photoSlider',
    eventHandle: eventHandle || ''
  });
  const getPageRefFromUrl = usePageRefFromUrl();

  useEffect(() => {
    if (pages.length) {
      const pageRef = getPageRefFromUrl(pages.map(page => ({ page }))) ?? { page: pages?.[0] };

      if (pageRef) {
        setIsWelcomePage(pageRef.page.type === EventPageType.welcome);
      }
    }
  }, [pages, getPageRefFromUrl]);

  if (websiteHeader && isWelcomePage) {
    return (
      <CustomizableHeader eventHandle={eventHandle || ''} telemetryPhotoEditor={telemetryEditPhotoActions} websiteHeader={websiteHeader} fontColor={artBackgroundFontColor}>
        <EventMenu
          eventProps={getEventMenuPropsFromEvent(event)}
          handleMenuOpenedChange={handleMenuOpenedChange}
          handleMenuClicked={handleMenuClicked}
          title={eventDisplayName}
          eventHandle={eventHandle || ''}
        />
      </CustomizableHeader>
    );
  }

  return (
    <LegacyHeader eventHandle={eventHandle || ''} telemetryPhotoEditor={telemetryEditPhotoActions} title={eventDisplayName} subtitle={greeting}>
      <EventMenu
        eventProps={getEventMenuPropsFromEvent(event)}
        handleMenuOpenedChange={handleMenuOpenedChange}
        handleMenuClicked={handleMenuClicked}
        title={eventDisplayName}
        eventHandle={eventHandle || ''}
      />
    </LegacyHeader>
  );
};

WebsiteHeader.displayName = 'WebsiteHeader';
